"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _SttButton = _interopRequireDefault(require("../SttButton/SttButton"));
var _SttCreateButton = _interopRequireDefault(require("../SttButton/SttCreateButton"));
var _SttSaveButton = _interopRequireDefault(require("../SttButton/SttSaveButton"));
var _SttClearButton = _interopRequireDefault(require("../SttButton/SttClearButton"));
var _SttSelectButton = _interopRequireDefault(require("../SttButton/SttSelectButton"));
var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _reactResponsive = require("react-responsive");
var _ArrowDropUp = _interopRequireDefault(require("@material-ui/icons/ArrowDropUp"));
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _SttVisualisadoresButton = _interopRequireDefault(require("../SttButton/SttVisualisadoresButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: "inline-block",
      textAlign: "left"
    },
    div: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderBottom: "3px solid ".concat(theme.palette.primary.main),
      borderRadius: '2px'
    },
    actions: _defineProperty({
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: theme.spacing(1),
      paddingBottom: theme.spacing(0.5)
    }, theme.breakpoints.down("xs"), {
      alignItems: "flex-start"
    }),
    menuBotoes: {
      display: 'flex',
      flexDirection: 'column'
    },
    wrapperMenu: {
      position: 'absolute',
      margin: '50px 0 0 0',
      zIndex: 1000
    },
    menuAcoes: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: theme.spacing(1),
      paddingBottom: theme.spacing(0.5)
    },
    actionButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
      paddingBottom: theme.spacing(0.5)
    },
    titleContainer: {
      display: "flex",
      alignItems: "center"
    }
  };
});
var getButton = function getButton(btn, index, actionButton) {
  var _btn$custom;
  var botaoCustonizado = ((_btn$custom = btn.custom) === null || _btn$custom === void 0 ? void 0 : _btn$custom.style) || {};
  if (btn.cadastrar) {
    return /*#__PURE__*/_react["default"].createElement(_SttCreateButton["default"], _extends({}, btn, {
      style: botaoCustonizado,
      key: index
    }));
  }
  if (btn.salvar) {
    return /*#__PURE__*/_react["default"].createElement(_SttSaveButton["default"], _extends({}, btn, {
      style: botaoCustonizado,
      key: index
    }));
  }
  if (btn.limpar) {
    return /*#__PURE__*/_react["default"].createElement(_SttClearButton["default"], _extends({}, btn, {
      style: botaoCustonizado,
      key: index
    }));
  }
  if (btn.visualizador) {
    return /*#__PURE__*/_react["default"].createElement(_SttVisualisadoresButton["default"], {
      visualizadores: btn.visualizadores,
      style: botaoCustonizado,
      key: index
    });
  }
  if (btn.selecao) {
    return /*#__PURE__*/_react["default"].createElement(_SttSelectButton["default"], _extends({}, btn, {
      style: botaoCustonizado,
      key: index
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    key: index,
    type: btn.type || "button",
    variant: actionButton ? "outlined" : btn.variant || "outlined",
    color: btn.color || "primary",
    size: btn.size || "medium",
    startIcon: btn.icon ? /*#__PURE__*/_react["default"].createElement(btn.icon, null) : null,
    disabled: btn.disabled || false,
    nomarginleft: btn.nomarginleft || "true",
    danger: btn.danger || undefined,
    onClick: btn.onClick || null,
    style: botaoCustonizado
  }, btn.descricao);
};
var getButtonAcoes = function getButtonAcoes(btn, index) {
  var _btn$custom2;
  var botaoCustonizado = ((_btn$custom2 = btn.custom) === null || _btn$custom2 === void 0 ? void 0 : _btn$custom2.style) || {};
  var styleAcoes = _objectSpread({
    textTransform: 'none',
    justifyContent: 'flex-start',
    padding: '8px 12px',
    color: '#757575',
    marginLeft: 0
  }, botaoCustonizado);

  // Omitir props específicas do getButton (variant, color, size, nomarginleft)
  btn.color = 'default';
  btn.variant = 'text';
  btn.size = 'medium';
  if (btn.cadastrar) {
    return /*#__PURE__*/_react["default"].createElement(_SttCreateButton["default"], _extends({}, btn, {
      style: styleAcoes,
      key: index
    }));
  }
  if (btn.salvar) {
    return /*#__PURE__*/_react["default"].createElement(_SttSaveButton["default"], _extends({}, btn, {
      style: styleAcoes,
      key: index
    }));
  }
  if (btn.limpar) {
    return /*#__PURE__*/_react["default"].createElement(_SttClearButton["default"], _extends({}, btn, {
      style: styleAcoes,
      key: index
    }));
  }
  if (btn.visualizador) {
    return /*#__PURE__*/_react["default"].createElement(_SttVisualisadoresButton["default"], {
      visualizadores: btn.visualizadores,
      style: styleAcoes,
      key: index
    });
  }
  if (btn.selecao) {
    return /*#__PURE__*/_react["default"].createElement(_SttSelectButton["default"], _extends({}, btn, {
      style: styleAcoes,
      key: index
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_core.Button, {
    key: index,
    type: btn.type || "button",
    disabled: btn.disabled || false,
    danger: btn.danger || false,
    onClick: btn.onClick || null,
    startIcon: btn.icon ? /*#__PURE__*/_react["default"].createElement(btn.icon, null) : null,
    color: btn.color || "default",
    variant: btn.variant || "text",
    size: btn.size || "medium",
    style: styleAcoes
  }, btn.descricao);
};
var SttContainerTitle = function SttContainerTitle(props) {
  var botoes = props.botoes,
    botaoAcoes = props.botaoAcoes,
    onClickVoltar = props.onClickVoltar,
    titulo = props.titulo;
  var classes = useStyles(props);
  var numeroBotoes = botoes ? botoes.filter(function (item) {
    return item.show;
  }).length : 0;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    mostrarBotoes = _useState2[0],
    setMostrarBotoes = _useState2[1];
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      var _document$getElementB;
      if (mostrarBotoes && !((_document$getElementB = document.getElementById('menu-botoes')) !== null && _document$getElementB !== void 0 && _document$getElementB.contains(event.target))) {
        setMostrarBotoes(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mostrarBotoes]);
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    className: classes.div
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 10,
    className: classes.titleContainer
  }, onClickVoltar && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "primary",
    disableRipple: true,
    size: "small",
    onClick: onClickVoltar
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBackIos["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h1",
    color: "primary",
    className: classes.root
  }, titulo)), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 2
  }, botoes ? numeroBotoes > 1 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.menuAcoes,
    onBlur: function onBlur(e) {
      // se o foco saiu completamente do container
      if (!e.currentTarget.contains(e.relatedTarget)) {
        setMostrarBotoes(false);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    nomarginleft: true,
    style: {
      width: 100
    },
    color: "primary",
    "aria-haspopup": "true",
    variant: "outlined",
    onClick: function onClick() {
      return setMostrarBotoes(!mostrarBotoes);
    },
    startIcon: mostrarBotoes ? /*#__PURE__*/_react["default"].createElement(_ArrowDropUp["default"], null) : /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], null)
  }, "A\xE7\xF5es"), mostrarBotoes && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapperMenu,
    id: "menu-botoes"
  }, /*#__PURE__*/_react["default"].createElement(_core.Paper, {
    className: classes.menuBotoes
  }, botoes === null || botoes === void 0 ? void 0 : botoes.map(function (btn, index) {
    return btn.show && getButtonAcoes(btn, index);
  })))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.actionButton
  }, botoes === null || botoes === void 0 ? void 0 : botoes.map(function (btn, index) {
    return btn.show && getButton(btn, index);
  })) : null));
};
var _default = SttContainerTitle;
exports["default"] = _default;